module.exports = __webpack_public_path__ + "images/sprites/ui/no-image_99ea13361f06a8031174e98a01c00180.png";